import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { IFormConfig } from '../../../../types/form-builder';
import FormBuilder from '../../../common/form-builder/FormBuilder';

export default function VesselHandledEditForm(props: {
  vesselType: any;
  vesselHandledRef: any;
}) {
  const { t } = useTranslation();
  const { control } = useFormContext();
  const { vesselType, vesselHandledRef } = props;

  const nameFormConfig: IFormConfig[] = [
    {
      class:
        'col-md-12 col-sm-12 col-lg-12 col-xs-12 col-xs-12 m-l-custom-sixteen-space-col',
      fieldWrapperClass: 'm-c-form-group mb-btm-space',
      name: 'vesselType',
      label: 'Ship Type',
      control: control,
      fieldType: 'select',
      dataSource: vesselType,
      displayExpr: 'optionValueText',
      valueExpr: 'optionValueCode',
      isRequired: true,
      ref: vesselHandledRef,
      rules: [
        {
          type: 'required',
          message: t('errors.required'),
        },
      ],
    },
    {
      class:
        'col-md-12 col-sm-12 col-lg-12 col-xs-12 col-xs-12 m-l-custom-sixteen-space-col',
      fieldWrapperClass: 'm-c-form-group mb-btm-space',
      name: 'vesselSize',
      label: 'Ship Size',
      control: control,
      fieldType: 'text',
      isRequired: true,
      maxLength: 100,
      ref: vesselHandledRef,
      rules: [
        {
          type: 'required',
          message: t('errors.required'),
        },
      ],
    },
  ];

  return (
    <div className="row m-l-custom-sixteen-space-row">
      <FormBuilder formConfig={nameFormConfig} />
    </div>
  );
}
